import React from 'react';
import HomeSubList from '../HomeSubList';
import HomeSubListSearchBox from '../HomeSubListSearchBox';
import './HomeSubListWrap.scss';

const HomeSubListWrap = (props) => {
  const { subPageList, setData, getList, updateSubPageStatus, deleteSubPage } = props;

  return (
    <div className="home-sub-list-wrap">
      {/* 서브 리스트 검색 박스*/}
      <HomeSubListSearchBox
        setData={(data) =>
          setData({
            path: ['subPageList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        searchData={subPageList.searchData}
        getList={getList}
      />

      {/* 서브 리스트 */}
      <HomeSubList
        subPageList={subPageList.list}
        pagination={subPageList.pagination}
        getList={getList}
        updateSubPageStatus={updateSubPageStatus}
        deleteSubPage={deleteSubPage}
      />
    </div>
  );
};

export default HomeSubListWrap;
